import React, { useId } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-final-form';
import { TextFieldPill } from '../../../01_atoms/FormElements';
import Button from '../../../01_atoms/Button';
import { currencySymbolPath } from '../../../../utils/currency';
import { composeParsers } from '../../../../utils/formFieldParsers';
import { composeValidators } from '../../../../utils/formFieldValidators';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../utils/behaviorSettings';

import styles from './index.module.scss';

const BBDonationWidget = ({
  title = 'I want to donate',
  currency,
  buttonLabel = 'Donate',
  placeholder = 'Enter amount',
  inputValidators = null,
  inputParsers = [],
  onSubmit,
  behaviorSettings = null,
  uuid = null,
}) => {
  const id = useId();

  return (
    <div
      data-component={'bb-donation-widget'}
      className={`bb ${styles['bb-donation-widget']} ${generateClassNameByBehaviorSettings(behaviorSettings)}`}
      id={uuid}
    >
      <div className="container">
        <div className={styles['bb-donation-widget__wrapper']}>
          {title && <div className={styles['bb-donation-widget__title']}>{title}</div>}

          <Form
            onSubmit={onSubmit}
            initialValues={{ currency }}
            subscription={{ submitting: true, valid: true }}
            render={({ handleSubmit, submitting, valid }) => (
              <form onSubmit={handleSubmit}>
                <TextFieldPill
                  name="amount"
                  placeholder={placeholder}
                  color="white"
                  icon={currencySymbolPath[currency]}
                  parse={inputParsers && composeParsers(...inputParsers)}
                  validate={inputValidators && composeValidators(...inputValidators)}
                  // Enable numeric keyboard for mobile devices.
                  inputMode="numeric"
                  pattern="[0-9]+"
                  infoOnPatternNotMatched="Please use numbers only"
                  id={id}
                />

                <Button
                  className="bb-donation-widget--button"
                  type="white-pink"
                  isLoading={submitting}
                  isDisabled={!valid}
                  withArrow={valid}
                  isUppercase
                  isOutlined
                >
                  {buttonLabel}
                </Button>
              </form>
            )}
          />
        </div>
      </div>
    </div>
  );
};

BBDonationWidget.propTypes = {
  currency: PropTypes.oneOf(['GBP', 'EUR']).isRequired,
  title: PropTypes.string,
  placeholder: PropTypes.string,
  buttonLabel: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  inputValidators: PropTypes.arrayOf(PropTypes.func),
  inputParsers: PropTypes.arrayOf(PropTypes.func),
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};

export default BBDonationWidget;
